import _ from 'lodash';
import React, {PropTypes} from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import FontAwesome from 'react-fontawesome';
import alasql from 'alasql';
import toastr from 'toastr';
import * as actions from '../../../actions/reportActions';
import * as eventActions from '../../../actions/eventActions';
// import DateInput from '../../../components/common/DateInput';
import DateTime from 'react-datetime';
import moment from 'moment-timezone';
import 'moment/locale/nb';
import Loading from '../../../components/Loading';
// import XLSX from 'xlsx';
import numeral from 'numeral';
import jsondiffpatch from 'jsondiffpatch';
global.XLSX=require('xlsx');
import '../../clubs/xlsx-shim';

import * as clubReg from './sql/clubReg';
import * as teamsSql from './sql/teams';
import * as contenderSQL from './sql/contenders';
import * as financialSql from './sql/financial';
// import * as diffUtils from './sql/diffUtils';
import * as teamDiffUtils from './sql/teamDiffUtils';
import * as contendersDiff from './sql/contendersDiff';

// window.xlsx = xlsx;

// Special function
alasql.fn.includeEmpty = function(a) {
	if(!a) return [undefined];
	if(a.length == 0) return [undefined];
	return a;
};

alasql.fn.includeEmptyArray = function(a) {
	if(!a) return [{}];
	if(a.length == 0) return [{}];
	return a;
};

alasql.aggr.CONCAT_STRINGS = function(value, accumulator, stage) {
		if(stage == 1) {
			// first call of aggregator - for first line
			let newAccumulator =  [value];
			return newAccumulator;
		} else if(stage == 2) {
			// for every line in the group
			accumulator.push(value);
			return accumulator;
		} else if(stage == 3) {
			// Post production - please nota that value Will be undefined
			return accumulator.sort().join(', ');
		}
};

alasql.fn.numeral = numeral;
// alasql.worker();

class ReportsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.loadDataFromServer = this.loadDataFromServer.bind(this);

    this.filteredTeamMembersCrossSQL = this.filteredTeamMembersCrossSQL.bind(this);

    this.getTeamMemberReport = this.getTeamMemberReport.bind(this);
		this.filteredTeamMembersSQL = this.filteredTeamMembersSQL.bind(this);
    this.returnTeamMemberList = this.returnTeamMemberList.bind(this);

		this.filteredTeamsSQL = this.filteredTeamsSQL.bind(this);
    this.returnTeamList = this.returnTeamList.bind(this);

    this.exportToExcel = this.exportToExcel.bind(this);

    this.updateTimeField = this.updateTimeField.bind(this);
    this.getTotalPerArticleReport = this.getTotalPerArticleReport.bind(this);
		this.returnTotalPerArticleReport = this.returnTotalPerArticleReport.bind(this);

		this.getClubInformation = this.getClubInformation.bind(this);
		this.returnClubInformation = this.returnClubInformation.bind(this);

		this.validReportDate = this.validReportDate.bind(this);
		this.validDiffDate = this.validDiffDate.bind(this);

		this.returnTotalPerArticleDiffReport = this.returnTotalPerArticleDiffReport.bind(this);

		this.getContender = this.getContender.bind(this);

		this.getReportDate = this.getReportDate.bind(this);

    this.state = {
      data: [{}],
      columns: [{}],
      loadingSQL: false,
      to_date: undefined,
      report_date: undefined,
      diff_date: undefined,
    };
  }

  componentWillMount() {
    if(this.props.eventId) {
      this.props.eventActions.loadEventTeamSettings(this.props.eventId);
      // this.loadDataFromServer();
    }
  }

  loadDataFromServer(e, date="") {
    if (e) {
      e.preventDefault();
    }
    if (this.props.loadingReports) {
      return false;
    }
    this.setState({
      data: []
    });
    let financialUrl = '' + this.props.eventId;
    let teamsUrl = this.props.eventId + '/team_type';
    if (date) {
      financialUrl = financialUrl + '/' + date.format("YYYY-MM-DD");
      teamsUrl = teamsUrl + '/' + date.format("YYYY-MM-DD");
    } else {
			date = moment(Date.now());
		}
    this.props.actions.loadReportDetails(financialUrl, date, 'regData');
    // this.props.actions.loadReportDetails(teamsUrl, date, 'teamData');
  }


	getReportDate() {
		if (this.state.report_date) {
			return this.state.report_date.format('YYYYMMDD');
		} else if(Object.keys(this.props.reportData).length > 0) {
			let date = moment(Object.keys(this.props.reportData)[0]);
			this.setState({
				report_date: date
			});
			return date.format('YYYYMMDD');
		} else {
			toastr.warning('Du må laste ned data og velge rapportdato',
				'Ingen dato valgt');
			return false;
		}
	}

  getTeamMemberReport(e, team) {
    e.preventDefault();
    let url = this.props.eventId + '/team_type/' + team.id;
    this.props.actions.loadReportDetails(url);
  }


	getClubInformation(e) {
		if (e) {
			e.preventDefault();
		}
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let data = this.props.reportData[reportDate]['regData'];
		let reportData = clubReg.clubRegInfo(data);
		let result;
		if (this.state.diff_date) {
			let diffDate = this.state.diff_date.format('YYYYMMDD');
			let diffData = this.props.reportData[diffDate]['regData'];
			let previousData = clubReg.clubRegInfo(diffData);

			let diff = jsondiffpatch.create({
				objectHash: function(obj) {
					// this function is used only to when objects are not equal by ref
					return obj.KlubbId;
				},
				arrays: {
					detectMove: false,
					includeValueOnMove: false
				},
			});
			let extraColumns = [
				{accessor: 'EndringsStatus', header: 'EndringsStatus'},
				{accessor: 'Tidligere_KlubbNavn', header: 'Tidligere_KlubbNavn'},
				{accessor: 'Tidligere_AktivPaamelding', header: 'Tidligere_AktivPåmelding'},
				{accessor: 'Tidligere_Kommentar', header: 'Tidligere_Kommentar'},
				{accessor: 'Tidligere_Kontaktperson_Navn', header: 'Tidligere_Kontaktperson_Navn'},
				{accessor: 'Tidligere_Kontaktperson_Tlf', header: 'Tidligere_Kontaktperson_Tlf'},
				{accessor: 'Tidligere_Kontaktperson_Epost', header: 'Tidligere_Kontaktperson_Epost'},
				{accessor: 'Tidligere_Kontaktperson_Adresse', header: 'Tidligere_Kontaktperson_Adresse'},
				{accessor: 'Tidligere_Kontaktperson_Kommune', header: 'Tidligere_Kontaktperson_Kommune'},
				{accessor: 'Tidligere_Kontaktperson_Fylke', header: 'Tidligere_Kontaktperson_Fylke'},
				{accessor: 'Tidligere_Kontaktperson_Postnummer', header: 'Tidligere_Kontaktperson_Postnummer'},
				{accessor: 'Tidligere_Kontaktperson_Land', header: 'Tidligere_Kontaktperson_Land'},
				{accessor: 'Tidligere_Fakturaadresse_Navn', header: 'Tidligere_Fakturaadresse_Navn'},
				{accessor: 'Tidligere_Fakturaadresse_Adresse', header: 'Tidligere_Fakturaadresse_Adresse'},
				{accessor: 'Tidligere_Fakturaadresse_Epost', header: 'Tidligere_Fakturaadresse_Epost'},
				{accessor: 'Tidligere_Fakturaadresse_Kommune', header: 'Tidligere_Fakturaadresse_Kommune'},
				{accessor: 'Tidligere_Fakturaadresse_Fylke', header: 'Tidligere_Fakturaadresse_Fylke'},
				{accessor: 'Tidligere_Fakturaadresse_Postnummer', header: 'Tidligere_Fakturaadresse_Postnummer'},
				{accessor: 'Tidligere_Fakturaadresse_Land', header: 'Tidligere_Fakturaadresse_Land'},
			]
			let dataResult, previousDataResult;
			let detailsDiff;
			Promise.all([reportData, previousData]).then((values) => {
				[dataResult, previousDataResult] = values;
				detailsDiff = diff.diff(dataResult, previousDataResult);
				result = clubReg.changesToClubReg(detailsDiff, previousDataResult);
				this.returnClubInformation(result, extraColumns)
			})
		} else {
			let data = alasql(`
		      SELECT * REMOVE COLUMNS Tidligere_AktivPaamelding
		      FROM ?
		    `, [reportData]);
			this.returnClubInformation(data);
		}
  }

	returnClubInformation(data, extraColumns=[]) {
		let columns = [
			{accessor: 'KlubbId', header: 'KlubbId'},
			{accessor: 'KlubbNavn', header: 'KlubbNavn'},
			{accessor: 'AktivPaamelding', header: 'AktivPåmelding'},
			{accessor: 'Kommentar', header: 'Kommentar'},
			{accessor: 'Kontaktperson_Navn', header: 'Kontaktperson_Navn'},
			{accessor: 'Kontaktperson_Tlf', header: 'Kontaktperson_Tlf'},
			{accessor: 'Kontaktperson_Epost', header: 'Kontaktperson_Epost'},
			{accessor: 'Kontaktperson_Adresse', header: 'Kontaktperson_Adresse'},
			{accessor: 'Kontaktperson_Kommune', header: 'Kontaktperson_Kommune'},
			{accessor: 'Kontaktperson_Fylke', header: 'Kontaktperson_Fylke'},
			{accessor: 'Kontaktperson_Postnummer', header: 'Kontaktperson_Postnummer'},
			{accessor: 'Kontaktperson_Land', header: 'Kontaktperson_Land'},
			{accessor: 'Fakturaadresse_Navn', header: 'Fakturaadresse_Navn'},
			{accessor: 'Fakturaadresse_Adresse', header: 'Fakturaadresse_Adresse'},
			{accessor: 'Fakturaadresse_Epost', header: 'Fakturaadresse_Epost'},
			{accessor: 'Fakturaadresse_Kommune', header: 'Fakturaadresse_Kommune'},
			{accessor: 'Fakturaadresse_Fylke', header: 'Fakturaadresse_Fylke'},
			{accessor: 'Fakturaadresse_Postnummer', header: 'Fakturaadresse_Postnummer'},
			{accessor: 'Fakturaadresse_Land', header: 'Fakturaadresse_Land'},
		];
		columns.push(...extraColumns);
		this.setState({
			data: data,
			activeReport: 'Klubbinformasjon',
			loadingSQL: false,
			columns: columns,
		});
	}


  getTotalPerArticleReport(e) {
    e.preventDefault();
    if (this.props.loadingReports) {
      return false;
    }
    this.setState({
      loadingSQL: true,
      activeReport: 'Fakturagrunnlag',
    });
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let data = this.props.reportData[reportDate]['regData'];
		financialSql.getFinancialReport(data).then(this.returnTotalPerArticleReport.bind(this));
  }

	returnTotalPerArticleReport(data) {
    this.setState({
      loadingSQL: false,
      data: data,
      columns: [
      {accessor: 'AktivPåmelding', header: 'AktivPåmelding'},
      {accessor: 'KlubbId', header: 'KlubbId'},
      {accessor: 'KlubbNavn', header: 'KlubbNavn'},
      {accessor: 'GrupperingsType', header: 'GrupperingsType'},
      {accessor: 'ArtikkelNavn', header: 'ArtikkelNavn'},
      {accessor: 'ArtikkelNr', header: 'ArtikkelNr'},
      {accessor: 'TotalPris', header: 'TotalPris'},
      {accessor: 'Antall', header: 'Antall'},
      ]
    });
  }

	returnTotalPerArticleDiffReport(data) {
    this.setState({
      loadingSQL: false,
      data: data,
      columns: [
      {accessor: 'AktivPåmelding', header: 'AktivPåmelding'},
      {accessor: 'KlubbNavn', header: 'KlubbNavn'},
      {accessor: 'GrupperingsType', header: 'GrupperingsType'},
      {accessor: 'ArtikkelNavn', header: 'ArtikkelNavn'},
      {accessor: 'ArtikkelNr', header: 'ArtikkelNr'},
      {accessor: 'TotalPris', header: 'TotalPris'},
      {accessor: 'Antall', header: 'Antall'},
			{accessor: 'KlubbId', header: 'KlubbId'},
      ]
    });
  }

  exportToExcel(e) {
    if (e) {
      e.preventDefault();
    }
    let reportName = this.state.activeReport + ' - ' + this.props.eventDetails.name;
    if (_.size(reportName) > 240) {
      reportName = reportName.substring(0,240);
    }
    alasql('SELECT * INTO XLSX("'+ reportName +'.xlsx",{headers:true}) FROM ?',[this.state.data]);
  }

	getContender(e) {
		if (e) {
			e.preventDefault();
		}
		this.setState({
      activeReport: 'Deltagere',
      loadingSQL: true,
    });
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let data = contenderSQL.contenderList(this.props.reportData[reportDate]['regData']);
		let result = data;
		let columns = [
			{accessor: 'KlubbNavn', header: 'KlubbNavn'},
			{accessor: 'AktivPaamelding', header: 'AktivPåmelding'},
			{accessor: 'FulltNavn', header: 'FulltNavn'},
			{accessor: 'Fornavn', header: 'Fornavn'},
			{accessor: 'Etternavn', header: 'Etternavn'},
			{accessor: 'KlubbId', header: 'KlubbId'},
			{accessor: 'PaameldingsId', header: 'PåmeldingsId'},
			{accessor: 'MedlemsId', header: 'MedlemsId'},
		];
		if (this.state.diff_date) {
			let previousData = contenderSQL.contenderList(
				this.props.reportData[this.state.diff_date.format('YYYYMMDD')]['regData']);
			let diff = jsondiffpatch.create({
				objectHash: function(obj) {
					// this function is used only to when objects are not equal by ref
					return obj.PaameldingsId;
				},
				arrays: {
					detectMove: false,
					includeValueOnMove: false
				},
			});
			let detailsDiff = diff.diff(data, previousData);
			result = contendersDiff.changesToContenders(detailsDiff, previousData);
			columns.push({accessor: 'EndringsStatus', header: 'EndringsStatus'});
			columns.push({accessor: 'Tidligere_AktivPaamelding', header: 'Tidligere_AktivPåmelding'});
		}
		this.setState({
			data: result,
			loadingSQL: false,
			columns: columns
		});
	}

	filteredTeamsSQL(e, team) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      activeReport: team.name + ' - Grupper',
      loadingSQL: true,
    });
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let data = teamsSql.teamsList(this.props.reportData[reportDate]['regData'], team.id);
		if (this.state.diff_date) {
			let previousData = teamsSql.teamsList(this.props.reportData[this.state.diff_date.format('YYYYMMDD')]['regData'], team.id);
			let diff = jsondiffpatch.create({
				objectHash: function(obj) {
					// this function is used only to when objects are not equal by ref
					return obj.GruppeId;
				},
				arrays: {
					detectMove: false,
					includeValueOnMove: false
				},
			});
			let detailsDiff = diff.diff(data, previousData);
			// console.log(data, previousData, detailsDiff);
			let diffResult = teamDiffUtils.changesToTeams(detailsDiff, previousData);
			this.setState({
				data: diffResult,
				loadingSQL: false,
				columns: [
					{accessor: "KlubbNavn", header: "KlubbNavn"},
					{accessor: "EndringsStatus", header: "EndringsStatus"},
					{accessor: "GruppeEndringsStatus", header: "GruppeEndringsStatus"},
					{accessor: "GruppeNavn", header: "GruppeNavn"},
					{accessor: "GruppeKategori", header: "GruppeKategori"},
					{accessor: "AktivPaamelding", header: "AktivPaamelding"},
					{accessor: "GrupperingsType", header: "GrupperingsType"},
					{accessor: "AntallMedlemmer", header: "AntallMedlemmer"},
					{accessor: "KlubbId", header: "KlubbId"},
					{accessor: "GruppeId", header: "GruppeId"},
					{accessor: "GrupperingsTypeId", header: "GrupperingsTypeId"},

					{accessor: "Tidligere_AktivPaamelding", header: "Tidligere_AktivPaamelding"},
					{accessor: "Tidligere_GruppeNavn", header: "Tidligere_GruppeNavn"},
					{accessor: "Tidligere_GruppeKategori", header: "Tidligere_GruppeKategori"},
					{accessor: "Tidligere_AntallMedlemmer", header: "Tidligere_AntallMedlemmer"},
				]
			});
		} else {
			this.returnTeamList(data);
		}
  }

	returnTeamList(data) {
    this.setState({
      data: data,
      loadingSQL: false,
      columns: [
				{accessor: "KlubbNavn", header: "KlubbNavn"},
				{accessor: "GruppeNavn", header: "GruppeNavn"},
				{accessor: "GruppeKategori", header: "GruppeKategori"},
				{accessor: "AktivPaamelding", header: "AktivPaamelding"},
				{accessor: "GrupperingsType", header: "GrupperingsType"},
				{accessor: "AntallMedlemmer", header: "AntallMedlemmer"},
				{accessor: "KlubbId", header: "KlubbId"},
				{accessor: "GruppeId", header: "GruppeId"},
				{accessor: "GrupperingsTypeId", header: "GrupperingsTypeId"},
      ]
    });
  }


  filteredTeamMembersSQL(e, team) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      activeReport: team.name + ' - Medlemmer',
      loadingSQL: true,
    });
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let data = teamsSql.teamMembersList(this.props.reportData[reportDate]['regData'], team.id);
		if (this.state.diff_date) {
			let previousData = teamsSql.teamMembersList(this.props.reportData[this.state.diff_date.format('YYYYMMDD')]['regData'], team.id);
			let diff = jsondiffpatch.create({
				objectHash: function(obj) {
					// this function is used only to when objects are not equal by ref
					return obj.LagMedlemsId;
				},
				arrays: {
					detectMove: false,
					includeValueOnMove: false
				},
			});
			let detailsDiff = diff.diff(data, previousData);
			// console.log(previousData.length, data.length, detailsDiff);

			let diffResult = teamDiffUtils.changesToTeamMembers(detailsDiff, previousData);
			this.setState({
				data: diffResult,
				loadingSQL: false,
				columns: [
					{accessor: "EndringsStatus", header: "EndringsStatus"},
					{accessor: "KlubbNavn", header: "KlubbNavn"},
					{accessor: "AktivPaamelding", header: "AktivPaamelding"},
					{accessor: "GruppeEndringsStatus", header: "GruppeEndringsStatus"},
					{accessor: "GrupperingsType", header: "GrupperingsType"},
					{accessor: "GrupperingsTypeId", header: "GrupperingsTypeId"},
					{accessor: "GruppeId", header: "GruppeId"},
					{accessor: "GruppeNavn", header: "GruppeNavn"},
					{accessor: "GruppeKategori", header: "GruppeKategori"},
					{accessor: "MedlemsEndringsStatus", header: "MedlemsEndringsStatus"},
					{accessor: "LagMedlemsId", header: "LagMedlemsId"},
					{accessor: "MedlemsId", header: "MedlemsId"},
					{accessor: "MedlemsNavn", header: "MedlemsNavn"},
					{accessor: "Fornavn", header: "Fornavn"},
					{accessor: "Etternavn", header: "Etternavn"},
					{accessor: "Fodselsdag", header: "Fødselsdag"},
					{accessor: "MedlemsKategorier", header: "MedlemsKategorier"},

					{accessor: "Tidligere_GruppeNavn", header: "Tidligere_GruppeNavn"},
					{accessor: "Tidligere_GruppeKategori", header: "Tidligere_GruppeKategori"},
					{accessor: "Tidligere_AktivPaamelding", header: "Tidligere_AktivPaamelding"},
					{accessor: "Tidligere_MedlemsKategorier", header: "Tidligere_MedlemsKategorier"},
				]
			});
		} else {
			this.returnTeamMemberList(data);
		}
  }

  returnTeamMemberList(data) {
    this.setState({
      data: data,
      loadingSQL: false,
      columns: [
				{accessor: "KlubbId", header: "KlubbId"},
				{accessor: "KlubbNavn", header: "KlubbNavn"},
				{accessor: "AktivPaamelding", header: "AktivPaamelding"},
				{accessor: "GruppeEndringsStatus", header: "GruppeEndringsStatus"},
				{accessor: "GrupperingsType", header: "GrupperingsType"},
				{accessor: "GrupperingsTypeId", header: "GrupperingsTypeId"},
				{accessor: "GruppeId", header: "GruppeId"},
				{accessor: "GruppeNavn", header: "GruppeNavn"},
				{accessor: "GruppeKategori", header: "GruppeKategori"},
				{accessor: "LagMedlemsId", header: "LagMedlemsId"},
				{accessor: "MedlemsId", header: "MedlemsId"},
				{accessor: "MedlemsNavn", header: "MedlemsNavn"},
				{accessor: "Fornavn", header: "Fornavn"},
				{accessor: "Etternavn", header: "Etternavn"},
				{accessor: "Fodselsdag", header: "Fødselsdag"},
				{accessor: "MedlemsKategorier", header: "MedlemsKategorier"},
      ]
    });
  }

	filteredTeamMembersCrossSQL(e, team, crossTeam) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      activeReport: 'Kryssrapport - ' + crossTeam.name,
      loadingSQL: true,
    });
		let reportDate = this.getReportDate();
		if (reportDate == false) {
			return;
		}
		let reportData = this.props.reportData[reportDate]['regData'];
		let data = teamsSql.teamMembersList(reportData, team.id);
		let dataCross = teamsSql.teamMembersList(reportData, crossTeam.id);
		let result = teamsSql.crossTeamReport(data, dataCross);

		let columns = [
			{accessor: "KlubbId", header: "KlubbId"},
			{accessor: "KlubbNavn", header: "KlubbNavn"},
			{accessor: "AktivPaamelding", header: "AktivPaamelding"},
			{accessor: "GruppeEndringsStatus", header: "GruppeEndringsStatus"},
			{accessor: "GrupperingsType", header: "GrupperingsType"},
			{accessor: "GrupperingsTypeId", header: "GrupperingsTypeId"},
			{accessor: "GruppeId", header: "GruppeId"},
			{accessor: "GruppeNavn", header: "GruppeNavn"},
			{accessor: "GruppeKategori", header: "GruppeKategori"},
			{accessor: "LagMedlemsId", header: "LagMedlemsId"},
			{accessor: "MedlemsId", header: "MedlemsId"},
			{accessor: "MedlemsNavn", header: "MedlemsNavn"},
			{accessor: "Fornavn", header: "Fornavn"},
			{accessor: "Etternavn", header: "Etternavn"},
			{accessor: "Fodselsdag", header: "Fødselsdag"},
			{accessor: "MedlemsKategorier", header: "MedlemsKategorier"},
			{accessor: "KryssGruppeNavn", header: "KryssGruppeNavn"},
			{accessor: "KryssGruppeKategori", header: "KryssGruppeKategori"},
			{accessor: "KryssMedlemsKategorier", header: "KryssMedlemsKategorier"},
    ];
		if (this.state.diff_date) {
			let date = this.state.diff_date.format('YYYYMMDD');
			let regdata = this.props.reportData[date]['regData'];
			let previousData = teamsSql.teamMembersList(regdata, team.id);
			let previousDataCross = teamsSql.teamMembersList(regdata, crossTeam.id);
			let previousResult = teamsSql.crossTeamReport(previousData,
				previousDataCross);

			let diff = jsondiffpatch.create({
				objectHash: function(obj) {
					// this function is used only to when objects are not equal by ref
					return obj.LagMedlemsId;
				},
				arrays: {
					detectMove: false,
					includeValueOnMove: false
				},
			});
			let detailsDiff = diff.diff(result, previousResult);
			let diffResult = teamDiffUtils.changesToTeamMembers(detailsDiff,
				previousData, teamDiffUtils.CROSS_TEAM_MEMBERS_CHANGE_FIELDS);

			result = diffResult;

			columns.push(...[
				{accessor: "Tidligere_GruppeNavn", header: "Tidligere_GruppeNavn"},
				{accessor: "Tidligere_GruppeKategori", header: "Tidligere_GruppeKategori"},
				{accessor: "Tidligere_AktivPaamelding", header: "Tidligere_AktivPaamelding"},
				{accessor: "Tidligere_MedlemsKategorier", header: "Tidligere_MedlemsKategorier"},

				{accessor: "Tidligere_KryssGruppeNavn", header: "Tidligere_KryssGruppeNavn"},
				{accessor: "Tidligere_KryssGruppeKategori", header: "Tidligere_KryssGruppeKategori"},
				{accessor: "Tidligere_KryssMedlemsKategorier", header: "Tidligere_KryssMedlemsKategorier"},
			]);
		}
		this.setState({
			data: result,
      loadingSQL: false,
      columns: columns,
		});
	}

	validReportDate(current) {
		let test = false;
		_.forEach(this.props.reportData, (data, key) => {
			if (moment(key).isSame(current, 'day')) {
				test = true;
			}
		});
		return test;
	}

	validDiffDate(current) {
		let test = false;
		_.forEach(this.props.reportData, (data, key) => {
			if (this.state.report_date &&
					this.state.report_date.isAfter(current) &&
					moment(key).isSame(current, 'day')) {
				test = true;
			}
		});
		return test;
	}

  updateTimeField(time, field='to_date') {
    return this.setState({
      [field]: time,
    });
  }

  render() {
    let yesterday = moment().add(0, 'day');
    let valid = function( current ) {
      let test = current.isBefore(yesterday);
      return test;
    };

    let disableMeny = (this.props.loadingReports ||
			_.isEmpty(this.props.reportData));
    return (
      <div className="container-fluid">
				<div className="panel panel-default">
					<div className="panel-body">
						<h5>Instruksjoner</h5>
						<ol>
							<li>Hent data for dagen du ønsker rapport fra.</li>
							<li>Velg rapportdato i feltet "rapportdato".
								<ul>
									<li>
										Velg differansedato hvis du ønsker å se endringer
										fra en dato til en annen.
										(Differanse gjelder kun for grupperinger)
									</li>
								</ul>
							</li>
							<li>Velg type rapport i menyen over tabellen</li>
						</ol>
					</div>
				</div>
        <div className="panel panel-default">
          <div className="panel-body">
            <div className="row">
              <div className="col-sm-6">
                <label htmlFor={'to_date'}>{'Hent rapportdata'}</label>
                <div className="row">
                  <div className="col-xs-8">
                    <DateTime
                      isValidDate={valid}
                      input={true}
                      locale="no"
                      value={this.state.to_date}
                      timeFormat={false}
                      inputProps={{
                        name: 'to_date',
                        placeholder: 'Velg dag'
                      }}
                      onChange={this.updateTimeField}/>
                  </div>
                  <div className="col-xs-4">
                   <button
                     onClick={(e) => {this.loadDataFromServer(e, this.state.to_date);}}
                     className={classNames('btn btn-primary btn-block', {
                       'disabled': this.props.loadingReports,
                     })}
                     type="button">
                     {'Hent'}
                   </button>
                 </div>
                </div>
              </div>
							<div className="col-sm-3">
								<label htmlFor={'report_date'}>
									{'Rapportdato'}
								</label>
								<DateTime
									isValidDate={this.validReportDate}
									input={true}
									locale="no"
									value={this.state.report_date}
									timeFormat={false}
									inputProps={{
										name: 'report_date',
										placeholder: 'Velg dag'
									}}
									onChange={(value) => {
										this.updateTimeField(value, 'report_date');}}/>
							</div>
							<div className="col-sm-3">
								<label htmlFor={'diff_date'}>
									{'Differansedato'}
								</label>
								<DateTime
									isValidDate={this.validDiffDate}
									input={true}
									locale="no"
									value={this.state.diff_date}
									timeFormat={false}
									inputProps={{
										name: 'diff_date',
										placeholder: 'Velg dag'
									}}
									onChange={(value) => {
										this.updateTimeField(value, 'diff_date');}}/>
							</div>
            </div>

          </div>
        </div>
        <nav className="navbar navbar-default navbar-custom">
          <div className="container-fluid">
            <ul className="nav navbar-nav">
							<li
								className={classNames({
									'disabled': disableMeny,
									'active': this.state.activeReport == 'Klubbinformasjon',
								})}
								role="presentation">
								<a href="#0"
									onClick={this.getClubInformation}
									target="_blank">
									{'Klubbinformasjon'}
								</a>
							</li>
							<li className={classNames({
									'disabled': disableMeny,
									'active': this.state.activeReport == 'Fakturagrunnlag',
								})}
								role="presentation">
								<a href="#0"
									onClick={this.getTotalPerArticleReport}
									target="_blank">
									{'Fakturagrunnlag'}
								</a>
							</li>
							<li
								className={classNames({
									'disabled': disableMeny,
									'active': this.state.activeReport == 'Deltagere',
								})}
								role="presentation">
								<a href="#0"
									onClick={this.getContender}
									target="_blank">
									{'Deltagere'}
								</a>
							</li>
              {this.props.teamList.map((team, index) => {
                return (
									<li key={index} className="dropdown">
										<a className="dropdown-toggle"
											data-toggle="dropdown"
											role="button"
											aria-haspopup="true"
											aria-expanded="false"
											target="_blank">
											{team.name}
											&nbsp;
											<span className="caret" />
										</a>
										<ul className="dropdown-menu">
											<li
												className={classNames({
													'disabled': disableMeny,
													'active': this.state.activeReport == (team.name + ' - Grupper'),
												})}
												role="presentation">
												<a href="#0"
													onClick={(e) => {this.filteredTeamsSQL(e, team);}}
													target="_blank">
													{team.name + ' - Grupper'}
												</a>
											</li>
											<li
												className={classNames({
													'disabled': disableMeny,
													'active': this.state.activeReport == (team.name + ' - Medlemmer'),
												})}
												role="presentation">
												<a href="#0"
													onClick={(e) => {this.filteredTeamMembersSQL(e, team);}}
													target="_blank">
													{team.name + ' - Medlemmer'}
												</a>
											</li>
											{this.props.teamList.map((crossTeam, index_nested) => {
												if (index_nested == index) {
													return null;
												}
												return (<li
													key={index_nested}
													className={classNames({
														'disabled': disableMeny,
														'active': this.state.activeReport == ('Kryssrapport - ' + crossTeam.name),
													})}
													role="presentation">
													<a href="#0"
														onClick={(e) => {
															this.filteredTeamMembersCrossSQL(e, team,
																crossTeam);
														}}
														target="_blank">
														{'Kryssrapport - ' + crossTeam.name}
													</a>
												</li>);
											})}
										</ul>
									</li>
                );
              })}
            </ul>
            <p className="navbar-text">
              <Loading loading={this.props.loading} />
            </p>
            <ul className="nav navbar-nav pull-right">
              <li>
                <button className="btn btn-primary navbar-btn"
                  onClick={this.exportToExcel}>
                  <FontAwesome name="file-excel-o" />
                  {' '}
                  Eporter til excel
                </button>
              </li>
            </ul>
          </div>
        </nav>

        <Loading loading={this.props.loadingReports || this.state.loadingSQL} />
        <div className="table-responsive">
          <ReactTable
            columns={this.state.columns}
            data={this.state.data}
            />
        </div>
      </div>
    );
  }
}

ReportsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  eventActions: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  pivotDetails: PropTypes.array,
  reportData: PropTypes.object,
  teamDetails: PropTypes.object,
  teamsData: PropTypes.array,
  eventDetailsUpdated: PropTypes.number.isRequired,
  teamList: PropTypes.array.isRequired,
  teamListUpdated: PropTypes.number.isRequired,
  eventId: PropTypes.string,
  loading: PropTypes.bool,
  loadingReports: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const eventId = ownProps.params.eventId;
  return {
    eventId: eventId,
    loading: state.events.loadingEvents,
    loadingReports: state.reports.ajaxRequests > 0,
    eventDetails: state.events.eventDetails,
    reportData: state.reports.reportData,
    pivotDetails: state.reports.pivotDetails,
    teamDetails: state.reports.teamDetails,
    teamsData: state.reports.teamsData,
    eventDetailsUpdated: state.events.eventDetailsUpdated,
    teamList: state.events.teamList,
    teamListUpdated: state.events.teamListUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    eventActions: bindActionCreators(eventActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsPage);



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/ReportsPage.js
 **/